<div class="segments">
  @for (segment of segments(); track segment) {
    @switch (segment.type) {
      @case ('text') {
        <span class="text">{{ segment.text }}</span>
      }
      @case ('id') {
        <ftr-selectable-id [id]="segment.id" (selected)="idSelected.emit($event)" />
      }
    }
  }
</div>
